__turbopack_context__.v({
  "Content": "xlnlBG_Content",
  "FooterHr": "xlnlBG_FooterHr",
  "FooterWrap": "xlnlBG_FooterWrap",
  "Form": "xlnlBG_Form",
  "Headline": "xlnlBG_Headline",
  "Preamble": "xlnlBG_Preamble",
  "Psa": "xlnlBG_Psa",
  "Root": "xlnlBG_Root",
  "Text": "xlnlBG_Text",
  "Title": "xlnlBG_Title",
  "Visible": "xlnlBG_Visible",
});
